import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useFormik } from 'formik';
import { styled} from '@mui/material/styles';
import { useNavigate, useLocation} from 'react-router-dom'
import ListServiceValidation from '../../validation/list-service'
import firebase, {auth} from '../../firebase/firebase'
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import Avatar from "@mui/material/Avatar/Avatar";
import Link from "@mui/material/Link/Link";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Chip from "@mui/material/Chip/Chip";
import PostNotification from "../../helpers/post-notification";
import ScrollToTop from '../../utils/scrollTop';
import PostActivity from "../../helpers/post-activity";
export default function ListServiceView(){




  const storageRef = firebase.storage().ref();

  const [loading, setLoading] = React.useState(false)
  const Input = styled('input')({
    display: 'none',
  })

  const [profileImage, setProfileImage] = React.useState();

  const {profile } = useContext(AuthUserContext);
  const navigator = useNavigate();
  const location= useLocation();
  const formik = useFormik({
    initialValues: ListServiceValidation.initialValues,
    validationSchema: ListServiceValidation.ListServiceSchema,
    onSubmit: async (values) => {
      console.log('Form data <========> ', JSON.stringify(values));
      console.log('Image path <========> ', profileImage?.path || '');
      try {
          const serviceRef = firebase.firestore().collection('services');
          const add = await serviceRef.add({
            uid: profile?.uid,
            name: profile.name,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            ...values,
            avatar: profileImage?.path || ''
          })
        await PostNotification({
          title: 'List service update',
          text: 'We are excited to inform that you successfully listed a new service.',
          uid: profile?.uid,
          createdBy:'self',
          link: '/artists/list-service-details/'+add.id,
        });
        PostActivity({
          text: `Listed your services"`,
          uid: profile.uid,
          createdBy:profile?.uid
        }).then()
          console.log('List service', add.id);
          navigator('/artists/dashboard')

      } catch (e) {
        setLoading(false)

      }
    },
  });
  const uploadFile = () => {

    setLoading(true)

    const file = profileImage?.file
    const path = `list-service/${profile?.uid}/profile-image/${file.name}`
    const uploadTask = storageRef.child(path).put(file);

    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        const image = {...profileImage, progress}
        setProfileImage(image)
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
        setLoading(false)

      },
      () => {
        setLoading(false)

        setProfileImage({...profileImage,path, progress:100})
      }
    );

  }
  return(
    <React.Fragment>
      <ScrollToTop/>
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}


      <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 5, marginBottom: 5 }}>
        <Container maxWidth="lg" sx={{textAlign:'left' ,}}>
          <Typography variant={'h4'} sx={{paddingX: 2}}>
            Add your details
          </Typography>
        </Container>
      </Container>
      <Container maxWidth="md" component="main" sx={{}}>

        <Stack direction="column"
               justifyContent="center"
               alignItems="center"
               spacing={2} sx={{mb: 5}}>
          <label htmlFor="profile-image">
            <Avatar alt={'Tabain'}  src={profileImage && profileImage?.src ? profileImage?.src :'/assets/default-avatar.png'} sx={{width: 220, height: 220, cursor: 'pointer' }} component={'span'} />
            <Input accept="image/*" id="profile-image" multiple={false} type="file" onChange={(e)=>{
              const fileReader = new FileReader();
              fileReader.readAsDataURL(e.target.files[0]);
              fileReader.addEventListener("load", async function () {
                setProfileImage({
                  progress:0,
                  src: this.result,
                  file: e.target.files[0],
                  size:  (e.target.files[0]?.size / 1024 / 1024).toFixed(2)


                });
              });
            }} />

          </label>
          <Button variant={'outlined'}  sx={{paddingX: 4}} component="span" onClick={uploadFile} disabled={!profileImage}>Upload {profileImage?.progress === 100 && <CheckCircleIcon style={{marginLeft: '15px'}}/>} {loading && <CircularProgress sx={{ml: 2}} size={20} color="primary"/>}</Button>
          {profileImage && profileImage?.src && <Link onClick={() => setProfileImage(undefined)}>Remove picture</Link>}
        </Stack>
      </Container>

      <Container maxWidth="md" component="main" sx={{textAlign: 'left'}}>
        <Stack  component={'form'}  direction={'column'} spacing={5} onSubmit={formik.handleSubmit}>
          <Typography variant={'h5'} >
            Biography
          </Typography>
          <TextField
            value={formik.values.biography}
            onChange={formik.handleChange}
            error={formik.touched.biography && Boolean(formik.errors.biography)}
            helperText={formik.touched.biography && formik.errors.biography}
            multiline
            rows={5}
            label={'Description'} name="biography" variant="outlined" sx={{width:'100%'}} />

          <Typography variant={'h5'} >
            About
          </Typography>

          <TextField
            value={formik.values.type}
            onChange={formik.handleChange}
            error={formik.touched.type && Boolean(formik.errors.type)}
            helperText={formik.touched.type && formik.errors.type}
            label={'Type of artist'} name="type" variant="outlined" sx={{width:'100%'}} select
            SelectProps={{
              multiple: true,
              value: formik.values.type,
            }}
          >
            
            <MenuItem value={'2D Modeling Artist'}>
              2D Modeling Artist
            </MenuItem>
            <MenuItem value={'3D Modeling Artist'}>
              3D Modeling Artist
            </MenuItem>
          
            <MenuItem value={'Character Artist'}>
              Character Artist
            </MenuItem>
            <MenuItem value={'Compositing Artist'}>
              Compositing Artist
            </MenuItem>
            <MenuItem value={'Lighting Artist'}>
              Lighting Artist
            </MenuItem>
            <MenuItem value={'Motion Graphic Artist'}>
              Motion Graphic Artist
            </MenuItem>
            <MenuItem value={'Rigging Artist'}>
              Rigging Artist
            </MenuItem>
            <MenuItem value={'Story Board Artist'}>
              Story Board Artist
            </MenuItem>
            <MenuItem value={'Other'}>
              Other
            </MenuItem>
          </TextField>
          {formik.values.type && formik.values.type.length > 0 &&

            <Grid container  spacing={2} >
              {formik.values.type.length > 0 && formik.values.type.map((d) => 
               <Chip label={d} variant="contained" xs={2} sx={{backgroundColor:'#E3E8F0',marginLeft:"5px",
													marginRight:"5px",
													marginBottom:"10px"}} fullWidth
                                                                                         onDelete={()=> formik.setFieldValue('type', formik.values.type.filter((f) => f !== d ))}/>)}
                                                                                        
            </Grid>}
          <TextField
            value={formik.values.gender}
            onChange={formik.handleChange}
            error={formik.touched.gender && Boolean(formik.errors.gender)}
            helperText={formik.touched.gender && formik.errors.gender}
            label={'Gender'} name="gender" variant="outlined" sx={{width:'100%'}} select>
             <MenuItem value={'Female'}>
              Female
            </MenuItem>
            <MenuItem value={'Male'}>
              Male
            </MenuItem>
          
            <MenuItem value={'Other'}>
              Other
            </MenuItem>
          </TextField>
          <TextField
            value={formik.values.location}
            onChange={formik.handleChange}
            error={formik.touched.location && Boolean(formik.errors.location)}
            helperText={formik.touched.location && formik.errors.location}


            label={'Location'} name="location" variant="outlined" sx={{width:'100%'}} select



          >
            {/* <MenuItem value={'china'}>
              China
            </MenuItem> */}
            <MenuItem value={'USA'}>
              USA
            </MenuItem>
            {/* <MenuItem value={'uk'}>
              UK
            </MenuItem> */}
          </TextField>
          <TextField
            value={formik.values.language}
            onChange={formik.handleChange}
            error={formik.touched.language && Boolean(formik.errors.language)}
            helperText={formik.touched.language && formik.errors.language}
            label={'Languages'} name="language" variant="outlined" sx={{width:'100%'}} select
            SelectProps={{
              multiple: true,
              value: formik.values.language,
            }}
          >
            <MenuItem value={'English'}>
              English
            </MenuItem>
          

            <MenuItem value={'French'}>
              French
            </MenuItem>
          
            <MenuItem value={'Spanish'}>
              Spanish
            </MenuItem>
          </TextField>
          {formik.values.language && formik.values.language.length > 0 &&

            <Stack direction="row" spacing={1}>
              {formik.values.language.length > 0 && formik.values.language.map((d) =>  <Chip label={d} variant="contained" sx={{backgroundColor:'#E3E8F0'}}
                                                                                     onDelete={()=> formik.setFieldValue('language', formik.values.language.filter((f) => f !== d ))}/>)}

            </Stack>}

          <Typography variant={'h5'} >
            Skills
          </Typography>


          <TextField

            label={'Skills'} name="skills" variant="outlined" sx={{width:'100%'}} select
            value={formik.values.skills}
            onChange={formik.handleChange}
            error={formik.touched.skills && Boolean(formik.errors.skills)}
            helperText={formik.touched.skills && formik.errors.skills}
            select
            sx={{textAlign:'left'}}
            SelectProps={{
              multiple: true,
              value: formik.values.skills,
            }}>
            <MenuItem value={'blender'}>
              blender
            </MenuItem>
            <MenuItem value={'maya'}>
              maya
            </MenuItem>
            <MenuItem value={'photoshop'}>
              photoshop
            </MenuItem>
            <MenuItem value={'unity 3D'}>
              unity 3D
            </MenuItem>
          </TextField>
          {formik.values.skills && formik.values.skills.length > 0 &&

            <Stack direction="row" spacing={1}>
              {formik.values.skills.length > 0 && formik.values.skills.map((d) =>  <Chip label={d} variant="contained" sx={{backgroundColor:'#E3E8F0'}}
                                                                                         onDelete={()=> formik.setFieldValue('skills', formik.values.skills.filter((f) => f !== d ))}/>)}

            </Stack>}
          {/*<TextField
            value={formik.values.skills}
            onChange={formik.handleChange}
            error={formik.touched.skills && Boolean(formik.errors.skills)}
            helperText={formik.touched.skills && formik.errors.skills}
            label={'Skills'} name="skills" variant="outlined" sx={{width:'100%'}} select

          >
            <MenuItem value={'blender'}>
              blender
            </MenuItem>
            <MenuItem value={'maya'}>
              maya
            </MenuItem>
            <MenuItem value={'photoshop'}>
              photoshop
            </MenuItem>
            <MenuItem value={'unity 3D'}>
              unity 3D
            </MenuItem>
          </TextField>*/}

          <Typography variant={'h5'} >
            Your work
          </Typography>
          <TextField
            value={formik.values.linkedin}
            onChange={formik.handleChange}
            error={formik.touched.linkedin && Boolean(formik.errors.linkedin)}
            helperText={formik.touched.linkedin && formik.errors.linkedin}
            label={'LinkedIn'} name="linkedin" variant="outlined" sx={{width:'100%'}} />
          <TextField
            value={formik.values.portfolio}
            onChange={formik.handleChange}
            error={formik.touched.portfolio && Boolean(formik.errors.portfolio)}
            helperText={formik.touched.portfolio && formik.errors.portfolio}
            label={'Portfolio link'} name="portfolio" variant="outlined" sx={{width:'100%'}} />
          <TextField
            value={formik.values.imdb}
            onChange={formik.handleChange}
            error={formik.touched.imdb && Boolean(formik.errors.imdb)}
            helperText={formik.touched.imdb && formik.errors.imdb}
            label={'IMDb link'} name="imdb" variant="outlined" sx={{width:'100%'}} />
          <TextField
            value={formik.values.other}
            onChange={formik.handleChange}
            error={formik.touched.other && Boolean(formik.errors.other)}
            helperText={formik.touched.other && formik.errors.other}
            label={'Other important links'}
            name="other" variant="outlined" sx={{width:'100%'}} />

          <Typography variant={'h5'} >
            Please add your bank details
          </Typography>

          <TextField
            value={formik.values.bd_country}
            onChange={formik.handleChange}
            error={formik.touched.bd_country && Boolean(formik.errors.bd_country)}
            helperText={formik.touched.bd_country && formik.errors.bd_country}
            label={'Country'} name="bd_country" variant="outlined" sx={{width:'100%'}} select
          >
            {/* <MenuItem value={'china'}>
              China
            </MenuItem> */}
            <MenuItem value={'USA'}>
              USA
            </MenuItem>
            {/* <MenuItem value={'uk'}>
              UK
            </MenuItem> */}
          </TextField>

          <TextField
            value={formik.values.bd_bankName}
            onChange={formik.handleChange}
            error={formik.touched.bd_bankName && Boolean(formik.errors.bd_bankName)}
            helperText={formik.touched.bd_bankName && formik.errors.bd_bankName}
            label={'Bank name'}
            name="bd_bankName" variant="outlined" sx={{width:'100%'}} />

          <TextField
            value={formik.values.bd_accountTitle}
            onChange={formik.handleChange}
            error={formik.touched.bd_accountTitle && Boolean(formik.errors.bd_accountTitle)}
            helperText={formik.touched.bd_accountTitle && formik.errors.bd_accountTitle}
            label={'Account title'}
            name="bd_accountTitle" variant="outlined" sx={{width:'100%'}} />

          <TextField
            value={formik.values.bd_recipientFullName}
            onChange={formik.handleChange}
            error={formik.touched.bd_recipientFullName && Boolean(formik.errors.bd_recipientFullName)}
            helperText={formik.touched.bd_recipientFullName && formik.errors.bd_recipientFullName}
            label={'Recipient’s full name'}
            name="bd_recipientFullName" variant="outlined" sx={{width:'100%'}} />

          <TextField
            value={formik.values.bd_recipientAddress}
            onChange={formik.handleChange}
            error={formik.touched.bd_recipientAddress && Boolean(formik.errors.bd_recipientAddress)}
            helperText={formik.touched.bd_recipientAddress && formik.errors.bd_recipientAddress}
            label={'Recipient’s address'}
            name="bd_recipientAddress" variant="outlined" sx={{width:'100%'}} />


          <TextField
            value={formik.values.bd_accountNumber}
            onChange={formik.handleChange}
            error={formik.touched.bd_accountNumber && Boolean(formik.errors.bd_accountNumber)}
            helperText={formik.touched.bd_accountNumber && formik.errors.bd_accountNumber}
            label={'Account number'}
            name="bd_accountNumber" variant="outlined" sx={{width:'100%'}} />

          <TextField
            value={formik.values.bd_swiftCode}
            onChange={formik.handleChange}
            error={formik.touched.bd_swiftCode && Boolean(formik.errors.bd_swiftCode)}
            helperText={formik.touched.bd_swiftCode && formik.errors.bd_swiftCode}
            label={'BIC / Swift code'}
            name="bd_swiftCode" variant="outlined" sx={{width:'100%'}} />
          {/*

*/}
          <Stack  direction="row"
                  justifyContent="center"
                  alignItems="center">

            <Button variant={'contained'} sx={{width:100}} type={'submit'}>
              Post
            </Button>

          </Stack>
          <div/>
          <div/>

        </Stack>
      </Container>

    </React.Fragment>
  )
}